import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NonworkableTaskTypeService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/nonworkabletasktypes`;

  constructor(private http: HttpClient) { }

  deactivate(customerId: number, taskTypeId: number, userId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/deactivate`, { customerId: customerId, taskTypeId: taskTypeId, userId: userId });
  }

  reactivate(customerId: number, taskTypeId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/reactivate`, { customerId: customerId, taskTypeId: taskTypeId });
  }
}
